module.exports = __webpack_public_path__ + "img/universkin-serum-p-icon.53f9dfe5.svg";